export default __webpack_public_path__ + "media/zurb/img/lab/thumbnails/thumb-e3a03294869c60b40c8bf13af8d050a3.jpg";